<app-loader
	[enableCircle]="true"
	[isActive]="this.isLoading$ | async"
	[isAfterViewInit]="false"
></app-loader>
<h1
	class="items-center justify-start gap-2"
	matDialogTitle
>
	<button
		(click)="prevStep()"
		*ngIf="hasStepper"
		mat-icon-button
	>
		<mat-icon>arrow_backward</mat-icon>
	</button>
	<div>{{ 'time.create' | translate }}</div>
	<div class="flex-auto"></div>
	<button
		mat-icon-button
		matDialogClose
		tabindex="-1"
	>
		<mat-icon>close</mat-icon>
	</button>
</h1>
<mat-dialog-content cdkTrapFocus>
	<form
		(submit)="$event.preventDefault()"
		[formGroup]="this.group"
		*ngIf="this.group as grp"
	>
		<div class="flex space-x-2">
			<div class="flex flex-auto flex-col items-stretch justify-stretch gap-2 lg:wflex-[1_0_440px]">
				<mat-form-field
					*ngIf="{ error: getErrorObservable('name') | async } as ctrl"
					appearance="standard"
				>
					<mat-label>{{ 'time.select' | translate }}</mat-label>
					<input
						cdkInitialFocus
						formControlName="name"
						matInput
						type="text"
					>
					<mat-hint *ngIf="(requireFields$ | async)?.name as fields">
						{{ 'errors.required' | translate: ({ field: 'time.name' } | translateArgs) }}
					</mat-hint>
					<mat-error *ngIf="ctrl.error as error">
						{{ error.content | translate: (error.args | translateArgs) }}
					</mat-error>
				</mat-form-field>
				<div class="flex flex-col space-y-0">
					<mat-form-field
						(click)="$event.preventDefault(); this.openProjectPicker()"
						*ngIf="{ error: getErrorObservable('project') | async } as ctrl"
						appearance="standard"
						class="cursor-pointer project-picker-field"
					>
						<div
							[style.backgroundColor]="group.value.project?.color"
							*ngIf="!group.value.project?.useAsDefault"
							class="project-color-dot"
							matPrefix
						></div>
						<mat-label [ngClass]="{'pl-6': group.value.project?.useAsDefault}">{{
							'project.select' | translate
						}}</mat-label>
						<input
							[isError]="group.controls.project.touched && ctrl.error"
							[ngModel]="
								group.value.project?.name
								? (group.value.project | defaultEntityTranslate: 'project' : 'project.none')
								: null
							"
							[ngModelOptions]="{ standalone: true }"
							class="cursor-pointer"
							matInput
							readonly
							type="text"
						>
						<button
							(click)="$event.preventDefault(); $event.stopPropagation(); resetProject()"
							*ngIf="group.value.project && this.defaultProject.id !== group.value.project.id"
							class="flex-shrink-0"
							mat-icon-button
							matSuffix
							type="button"
						>
							<mat-icon>clear</mat-icon>
						</button>
						<mat-hint *ngIf="(requireFields$ | async)?.project as fields">
							{{ 'errors.record.project-req' | translate }}
						</mat-hint>
						<mat-error *ngIf="ctrl.error as error">{{
							error.content | translate: error.args || {}
						}}</mat-error>
					</mat-form-field>
					<div
						*ngIf="(group.value.project | projectProxy)?.description as desc"
						class="mb-4 rounded bg-neutral-800/5 px-2.5 py-3 text-sm dark:bg-black/20"
					>
						{{ desc }}
					</div>
				</div>
				<ng-container *ngIf="group.value.project?.tags?.length">
					<div class="flex flex-wrap gap-2">
						<div
							*ngFor="let item of group.value.project?.tags; trackBy: trackId"
							class="mbg-card pointer-events-none h-6 cursor-default select-none rounded-full px-2.5 text-base leading-6"
						>
							{{ item.name }}
						</div>
					</div>
				</ng-container>
				<mat-form-field
					(click)="$event.preventDefault(); this.openTaskPicker()"
					[class.cursor-pointer]="!taskDisabled"
					*ngIf="{ error: getErrorObservable('task') | async } as ctrl"
					appearance="standard"
					class="w-full"
				>
					<mat-label>{{ 'task.select' | translate }}</mat-label>
					<input
						[class.cursor-pointer]="!taskDisabled"
						[disabled]="taskDisabled"
						[isError]="group.controls.task.touched && ctrl.error"
						[ngModel]="group.value.task?.name"
						[ngModelOptions]="{ standalone: true }"
						#taskPickerInput
						matInput
						readonly
						type="text"
					>
					<button
						(click)="$event.preventDefault(); $event.stopPropagation(); group.patchValue({ task: null })"
						[disabled]="taskPickerInput.disabled"
						*ngIf="group.value.task"
						mat-icon-button
						matSuffix
						type="button"
					>
						<mat-icon>clear</mat-icon>
					</button>
					<mat-hint *ngIf="(requireFields$ | async)?.task as fields">
						{{ 'errors.record.desc-required' | translate }}
					</mat-hint>
					<mat-error *ngIf="ctrl.error as error">{{ error.content | translate: error.args || {} }}</mat-error>
				</mat-form-field>
				<div class="flex w-full cursor-pointer flex-col">
					<mat-form-field
						(click)="!$event.defaultPrevented && openTagsPicker()"
						appearance="standard"
					>
						<mat-label>{{ 'tag.select' | translate }}</mat-label>
						<input
							[value]="grp.value.tags | mapProp: 'name' | joinString: ', '"
							class="cursor-pointer"
							matInput
							readonly
							type="text"
						>
						<button
							(click.native)="grp.controls.tags.setValue([])"
							*ngIf="grp.value.tags && grp.value.tags.length > 0"
							mat-icon-button
							matSuffix
							type="button"
						>
							<mat-icon>clear</mat-icon>
						</button>
						<mat-error *ngIf="!grp.value.tags"
							>{{ 'errors.required' | translate: { field: 'Tags' | translate } }}*</mat-error
						>
					</mat-form-field>
				</div>
				<div
					(click)="$event.preventDefault(); openUserPicker()"
					*ngIf="(workspace$isAdmin.value$ | async) || (userIsWorkspaceManager.value$ | async)"
					class="flex w-full cursor-pointer flex-col"
				>
					<mat-form-field
						appearance="standard"
						class="form-control-interactive"
					>
						<mat-label>{{ 'user.select' | translate }}</mat-label>
						<div
							*ngIf="group.value.user as user"
							class="-mb-16px flex items-center space-x-1.5"
						>
							<app-user-avatar
								[userId]="user.id"
								class="rounded-full"
								size="40px"
							></app-user-avatar>
							<div class="flex flex-auto flex-col leading-none">
								<span>{{ user.name }}</span>
								<span class="mat-hint text-sm">{{ user.email }}</span>
							</div>
							<button
								(click)="$event.preventDefault(); $event.stopPropagation(); patchValue({ user: null })"
								*ngIf="postDiffUser$ | async"
								mat-icon-button
							>
								<mat-icon>clear</mat-icon>
							</button>
						</div>
						<input
							[value]="group.value.user"
							class="!pointer-events-none"
							matInput
							readonly
						>
					</mat-form-field>
				</div>
				<div
					(click)="$event.preventDefault(); openCalPicker()"
					class="flex w-full cursor-pointer flex-col"
				>
					<mat-form-field
						appearance="standard"
						class="pointer-events-none"
					>
						<mat-label>{{ 'timer.date' | translate }}</mat-label>
						<input
							[value]="grp.value.date | formatDate"
							class="!pointer-events-none"
							matInput
						>
					</mat-form-field>
				</div>
				<div class="flex items-center space-x-2">
					<ng-container
						*ngTemplateOutlet="
              mode === 'range'
                ? rangeModeTemplate
                : mode === 'range_optional'
                  ? stateVisibleMode
                    ? rangeModeTemplate
                    : durationModeTemplate
                  : mode === 'duration'
                    ? durationModeTemplate
                    : null
            "
					></ng-container>
					<ng-container *ngIf="mode === 'range_optional'">
						<button
							(click)="stateVisibleMode = !stateVisibleMode"
							[matTooltip]="'timer.time.changeInputMode' | translate"
							[matTooltipOptions]="{ hideOnClick: false }"
							mat-icon-button
							type="button"
						>
							<mat-icon>swap_horiz</mat-icon>
						</button>
					</ng-container>
				</div>
				<mat-checkbox
					class="mb-4"
					color="primary"
					formControlName="billable"
				>
					{{ 'Billable_Alt' | translate }}
				</mat-checkbox>
			</div>
			<div
				class="events-container relative flex flex-col md:wflex-[1_0_auto]"
				fxHide.lt-md
				tabindex="-1"
			>
				<mwl-calendar-day-view
					(eventTimesChanged)="onCalChange($event)"
					[events]="this.events$ | async"
					[eventTemplate]="eventTemplate"
					[hourSegmentHeight]="30"
					[hourSegments]="4"
					[hourSegmentTemplate]="weekViewHourSegmentTemplate"
					[viewDate]="this.group.value.date"
					class="scroll-y mb-2 h-[650px] max-h-full"
					id="cal-day-view"
					tabindex="-1"
				></mwl-calendar-day-view>
			</div>
		</div>
	</form>
</mat-dialog-content>
<ng-container *ngIf="getErrorObservable('date') | async as error">
	<ng-container *ngIf="error as br">
		<div class="absolute inset-x-0 bottom-0 mx-3 mb-14">
			<div class="alert alert-danger alert-tight rounded py-2">
				{{ br.content | translate: (br.args || {} | translateArgs) }}
			</div>
		</div>
	</ng-container>
</ng-container>
<mat-dialog-actions class="mat-action-filled">
	<button
		(click)="this.addEntry()"
		[disabled]="this.group.invalid"
		class="mat-action-filled"
		color="primary"
		mat-flat-button
	>
		{{ this.i18n?.submit || 'time.create' | translate }}
	</button>
</mat-dialog-actions>
<mat-menu #timeContextMenu="matMenu">
	<ng-template
		let-data
		matMenuContent
	>
		<button
			(click)="setToNow(data.prop)"
			mat-menu-item
		>
			{{ 'timeContextMenu.setTo.now' | translate }}
		</button>
		<button
			[matMenuTriggerData]="{ $implicit: data }"
			[matMenuTriggerFor]="timeContextMenuTimeTemplates"
			mat-menu-item
		>
			{{ 'timeContextMenu.setToMore' | translate }}
		</button>
	</ng-template>
</mat-menu>
<mat-menu #timeContextMenuTimeTemplates="matMenu">
	<ng-template
		let-data
		matMenuContent
	>
		<button
			(click)="setMinutesDiff(5, data.prop)"
			mat-menu-item
		>
			{{ 'timeContextMenu.setTo.MinDiffs' | translate: { value: 5 } }}
		</button>
		<button
			(click)="setMinutesDiff(10, data.prop)"
			mat-menu-item
		>
			{{ 'timeContextMenu.setTo.MinDiffs' | translate: { value: 10 } }}
		</button>
		<button
			(click)="setMinutesDiff(15, data.prop)"
			mat-menu-item
		>
			{{ 'timeContextMenu.setTo.MinDiffs' | translate: { value: 15 } }}
		</button>
		<button
			(click)="setMinutesDiff(30, data.prop)"
			mat-menu-item
		>
			{{ 'timeContextMenu.setTo.MinDiffs' | translate: { value: 30 } }}
		</button>
		<button
			(click)="setHourDiff(1, data.prop)"
			mat-menu-item
		>
			{{ 'timeContextMenu.setTo.HrDiff' | translate: { value: 1 } }}
		</button>
		<button
			(click)="setHourDiff(2, data.prop)"
			mat-menu-item
		>
			{{ 'timeContextMenu.setTo.HrDiffs' | translate: { value: 2 } }}
		</button>
		<button
			(click)="setHourDiff(4, data.prop)"
			mat-menu-item
		>
			{{ 'timeContextMenu.setTo.HrDiffs' | translate: { value: 4 } }}
		</button>
		<button
			(click)="setWorkDay()"
			mat-menu-item
		>
			{{ 'timeContextMenu.setTo.1workDay' | translate }}
		</button>
	</ng-template>
</mat-menu>
<div
	[matMenuTriggerFor]="timeContextMenu"
	[style.left]="timeContextMenuPosition.x"
	[style.top]="timeContextMenuPosition.y"
	#timeContextMenuTrigger="matMenuTrigger"
	style="visibility: hidden; position: fixed"
></div>
<ng-template
	#weekViewHourSegmentTemplate
	let-isTimeLabel="isTimeLabel"
	let-locale="locale"
	let-segment="segment"
	let-segmentHeight="segmentHeight"
>
	<div
		[class.cal-after-hour-start]="!segment.isStart"
		[class.cal-hour-start]="segment.isStart"
		[ngClass]="segment.cssClass"
		[style.height.px]="segmentHeight"
		#segmentElement
		class="cal-hour-segment"
	>
		<div
			*ngIf="isTimeLabel && (this.currentFormat$ | async) as format"
			class="cal-time"
		>
			{{ segment.date | formatDate: 'time' }}
		</div>
	</div>
</ng-template>
<ng-template #rangeModeTemplate>
	<ng-container
		[formGroup]="group"
		*ngIf="{ error: groupErrors } as ctrl"
	>
		<div class="flex flex-1 flex-col">
			<div class="flex flex-row items-center justify-between">
				<app-time-input
					(click)="$event.stopPropagation(); this.selectInput($event, startInpRef)"
					(contextmenu)="
            this.onTimeContextMenuTrigger($event, {
              time: this.group.value.start,
              prop: 'start',
            })
          "
					(focus)="this.selectInput($event, startInpRef)"
					(keydown.enter)="$event.preventDefault()"
					[displayFormat]="false"
					[inputPlaceholder]="'timer.time.start' | translate"
					[maxlength]="5"
					#startInpRef="nativeElement"
					#tStartFormField
					class="wflex-[0_0_74px]"
					elementRef
					formControlName="start"
					matInput
				>
					<ng-template
						let-control="control"
						let-inputPlaceholder="inputPlaceholder"
						timeInputControl
					>
						<mat-form-field
							appearance="standard"
							fxFill
						>
							<mat-label translate>timer.time.start</mat-label>
							<input
								[formControl]="control"
								[isError]="(group.errors?.same && group.errors) || group.errors?.range"
								[placeholder]="inputPlaceholder"
								matInput
								type="text"
							>
						</mat-form-field>
					</ng-template>
				</app-time-input>
				<span class="tg-seperator mx-2"> <mat-icon>arrow_forward</mat-icon> </span>
				<app-time-input
					(click)="$event.stopPropagation(); this.selectInput($event, endInpRef)"
					(contextmenu)="
            this.onTimeContextMenuTrigger($event, {
              time: this.group.value.end,
              prop: 'end',
            })
          "
					(focus)="this.selectInput($event, endInpRef)"
					(keydown.enter)="$event.preventDefault()"
					[displayFormat]="false"
					[inputPlaceholder]="'timer.time.end' | translate"
					[maxlength]="5"
					#endInpRef="nativeElement"
					#tEndFormField
					class="wflex-[0_0_74px]"
					elementRef
					formControlName="end"
					matInput
				>
					<ng-template
						let-control="control"
						let-inputPlaceholder="inputPlaceholder"
						timeInputControl
					>
						<mat-form-field
							appearance="standard"
							fxFill
						>
							<mat-label translate>timer.time.end</mat-label>
							<input
								[formControl]="control"
								[isError]="(group.errors?.same && group.errors) || group.errors?.range"
								[placeholder]="inputPlaceholder"
								matInput
								type="text"
							>
						</mat-form-field>
					</ng-template>
				</app-time-input>
			</div>
			<div
				*ngIf="ctrl.error as err"
				class="mat-error mat-typography -mt-4 text-sm"
			>
				{{ err | translate }}
			</div>
		</div>
	</ng-container>
</ng-template>
<ng-template #durationModeTemplate>
	<div class="flex flex-1 flex-col">
		<ng-container [formGroup]="group">
			<tg-duration-input-control
				displayFormat="HH:mm"
				formControlName="duration"
			>
				<ng-template
					durationInputControl
					let-control="control"
					let-inputPlaceholder="inputPlaceholder"
					let-name="name"
				>
					<mat-form-field
						appearance="standard"
						fxFill
					>
						<mat-label translate>timer.time.duration</mat-label>
						<input
							[formControl]="control"
							matInput
							type="text"
						>
					</mat-form-field>
				</ng-template>
			</tg-duration-input-control>
		</ng-container>
	</div>
</ng-template>
<ng-template
	#eventTemplate
	let-column="column"
	let-daysInWeek="daysInWeek"
	let-eventClicked="eventClicked"
	let-tooltipAppendToBody="tooltipAppendToBody"
	let-tooltipDelay="tooltipDelay"
	let-tooltipDisabled="tooltipDisabled"
	let-tooltipPlacement="tooltipPlacement"
	let-tooltipTemplate="tooltipTemplate"
	let-weekEvent="weekEvent"
>
	<div
		(mwlClick)="eventClicked.emit({ sourceEvent: $event })"
		(mwlKeydownEnter)="eventClicked.emit({ sourceEvent: $event })"
		[attr.aria-label]="
      { event: weekEvent.tempEvent || weekEvent.event, locale: locale } | calendarA11y: 'eventDescription'
    "
		[mwlCalendarTooltip]="
      !tooltipDisabled
        ? (weekEvent.event.title
          | calendarEventTitle
            : (daysInWeek === 1 ? 'dayTooltip' : 'weekTooltip')
            : weekEvent.tempEvent || weekEvent.event)
        : ''
    "
		[ngStyle]="{
      backgroundColor: weekEvent.event.color?.secondary,
      borderColor: weekEvent.event.color?.primary,
    }"
		[tooltipAppendToBody]="tooltipAppendToBody"
		[tooltipDelay]="tooltipDelay"
		[tooltipEvent]="weekEvent.tempEvent || weekEvent.event"
		[tooltipPlacement]="tooltipPlacement"
		[tooltipTemplate]="tooltipTemplate"
		class="cal-event"
		role="application"
		tabindex="-1"
	>
		<mwl-calendar-event-actions
			[customTemplate]="eventActionsTemplate"
			[event]="weekEvent.tempEvent || weekEvent.event"
		></mwl-calendar-event-actions>
		&ngsp;
		<mwl-calendar-event-title
			[customTemplate]="eventTitleTemplate"
			[event]="weekEvent.tempEvent || weekEvent.event"
			[view]="daysInWeek === 1 ? 'day' : 'week'"
		></mwl-calendar-event-title>
	</div>
</ng-template>
